/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BookingInformationQueryVariables = {
    bookingId: string;
    checkDate: string;
    lang: string;
    prefixes: Array<string>;
};
export type BookingInformationQueryResponse = {
    readonly lastBookingStatus: {
        readonly bookingStatus: string | null;
        readonly lastBooking: string | null;
    } | null;
    readonly mandant: {
        readonly modules: ReadonlyArray<{
            readonly name: string;
            readonly enabled: boolean;
        } | null> | null;
    } | null;
    readonly translationList: {
        readonly translations: ReadonlyArray<{
            readonly component: string | null;
            readonly text: string | null;
        } | null> | null;
    } | null;
    readonly viewer: {
        readonly rights: ReadonlyArray<{
            readonly right: string | null;
        } | null> | null;
    } | null;
};
export type BookingInformationQuery = {
    readonly response: BookingInformationQueryResponse;
    readonly variables: BookingInformationQueryVariables;
};



/*
query BookingInformationQuery(
  $bookingId: String!
  $checkDate: String!
  $lang: String!
  $prefixes: [String!]!
) {
  lastBookingStatus(bookingId: $bookingId, date: $checkDate) {
    bookingStatus
    lastBooking
  }
  mandant {
    modules {
      name
      enabled
    }
  }
  translationList(lang: $lang, prefixes: $prefixes) {
    translations {
      component
      text
    }
  }
  viewer {
    rights {
      right
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "checkDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lang"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "prefixes"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      },
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "checkDate"
      }
    ],
    "concreteType": "LastBookingStatus",
    "kind": "LinkedField",
    "name": "lastBookingStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastBooking",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Mandant",
    "kind": "LinkedField",
    "name": "mandant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Module",
        "kind": "LinkedField",
        "name": "modules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      },
      {
        "kind": "Variable",
        "name": "prefixes",
        "variableName": "prefixes"
      }
    ],
    "concreteType": "TranslationList",
    "kind": "LinkedField",
    "name": "translationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Translation",
        "kind": "LinkedField",
        "name": "translations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "component",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Right",
        "kind": "LinkedField",
        "name": "rights",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "right",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingInformationQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookingInformationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "09f5c44a8fe204c9696f8d64403b23b9",
    "id": null,
    "metadata": {},
    "name": "BookingInformationQuery",
    "operationKind": "query",
    "text": "query BookingInformationQuery(\n  $bookingId: String!\n  $checkDate: String!\n  $lang: String!\n  $prefixes: [String!]!\n) {\n  lastBookingStatus(bookingId: $bookingId, date: $checkDate) {\n    bookingStatus\n    lastBooking\n  }\n  mandant {\n    modules {\n      name\n      enabled\n    }\n  }\n  translationList(lang: $lang, prefixes: $prefixes) {\n    translations {\n      component\n      text\n    }\n  }\n  viewer {\n    rights {\n      right\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '299c0ee52e3be399974a9dc7d5e5c9bf';
export default node;
